import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    '& .MuiBreadcrumbs-separator': {
      margin: 0,
      color: 'inherit',
    },
  },
}))
